import {type ICurrencyConfiguration} from '../../../@type/woocommerce/currency-configuration';
import {type IMerchantConfiguration} from '../models/IMerchantConfiguration';
import {type DispatchAction, store} from '../store';
import {DispatchActionType} from '../models/DispatchActionType';
import {createDispatchUpdate} from './initialState';

/**
 * Merchant settings reducer.
 */
export function merchantConfigurationReducer(state: IMerchantConfiguration, action: DispatchAction<unknown>): IMerchantConfiguration {
	switch (action.type) {
		case DispatchActionType.MERCHANT_GENERAL_CURRENCY:
			return {
				...state,
				general: {
					...state.general,
					currency: {
						...(action as DispatchAction<ICurrencyConfiguration>).payload,
					},
				},
			};
		case DispatchActionType.MERCHANT_TAX:
			return {
				...state,
				tax: {
					...(action as DispatchAction<IMerchantConfiguration['tax']>).payload,
				},
			};
		case DispatchActionType.MERCHANT_SHIPPING:
			return {
				...state,
				shipping: {
					...(action as DispatchAction<IMerchantConfiguration['shipping']>).payload,
				},
			};
		default:
			return {...state};
	}
}

// ======================== Action Creators ==============================

export const updateMerchantCurrencyConfig = createDispatchUpdate<ICurrencyConfiguration>(DispatchActionType.MERCHANT_GENERAL_CURRENCY);
export const updateMerchantTaxConfig = createDispatchUpdate<IMerchantConfiguration['tax']>(DispatchActionType.MERCHANT_TAX);
export const updateMerchantGeneralConfig = createDispatchUpdate<IMerchantConfiguration['general']>(DispatchActionType.MERCHANT_GENERAL);
export const updateMerchantShippingConfig = createDispatchUpdate<IMerchantConfiguration['shipping']>(DispatchActionType.MERCHANT_SHIPPING);

// ========================= Store Selectors ===========================

export const MerchantConfiguration = {
	general: {
		wcLocationInfoData: () => store.getState().merchantConfiguration.general.wcLocationInfoData,
	},
	currency: {
		configuration: () => store.getState().merchantConfiguration.general.currency,
		code: () => store.getState().merchantConfiguration.general.currency.code,
		symbol: () => store.getState().merchantConfiguration.general.currency.symbol,
	},
	tax: {
		displayMode: () => store.getState().merchantConfiguration.tax.displayPricesInCartAndCheckout,
	},
	shipping: {
		shippingZones: () => store.getState().merchantConfiguration.shipping.shippingZones,
	},
};
